import React, { forwardRef } from "react";
import { useIntl } from "react-intl";
import { useTreeItemUtils, useTreeItem, TreeItemProvider, TreeItemRoot, TreeItemGroupTransition } from "@mui/x-tree-view";
import { makeStyles } from "tss-react/mui";
import "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const useStyles = makeStyles()((theme, _, classes) => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1, 2.5),
    minHeight: theme.spacing(6),
    borderRadius: "6px",
    "& + .MuiCollapse-root": {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(2),
      "& > .MuiCollapse-wrapper": {
        borderLeft: "1px solid #cccccc",
        paddingLeft: theme.spacing(2)
      },
      "& .MuiTreeItem-content": {
        paddingLeft: theme.spacing(2)
      }
    },
    [`&:hover, &.${classes.selected}`]: {
      background: theme.palette.primary.light + "!important"
    },
    [`& .${classes.iconContainer}`]: {
      marginRight: 0,
      justifyContent: "left"
    },
    [`& .${classes.label}`]: {
      paddingLeft: 0
    }
  },
  iconContainer: {
    fontSize: "18px",
    color: theme.palette.secondary.main,
    minWidth: theme.spacing(4)
  },
  selected: {
    color: theme.palette.primary.main
  },
  label: {
    flexGrow: 1,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    paddingRight: theme.spacing(1)
  },
  expander: {
    color: theme.palette.secondary.main,
    fontSize: "10px"
  }
}));
const MenuTreeItemInner = forwardRef(
  ({
    id,
    itemId,
    label,
    disabled,
    children,
    hasChildren,
    icon,
    ...other
  }, ref) => {
    const { interactions } = useTreeItemUtils({ itemId });
    const {
      status: { selected, expanded },
      getContextProviderProps,
      getRootProps,
      getGroupTransitionProps
    } = useTreeItem({ itemId, id, label, disabled, children });
    const { classes: defaultClasses, cx } = useStyles();
    return /* @__PURE__ */ React.createElement(TreeItemProvider, { ...getContextProviderProps() }, /* @__PURE__ */ React.createElement(TreeItemRoot, { ...getRootProps(other) }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(defaultClasses.root, selected && defaultClasses.selected),
        key: itemId,
        id: itemId,
        ref,
        onClick: (e) => hasChildren ? interactions.handleExpansion(e) : interactions.handleSelection(e)
      },
      icon ? /* @__PURE__ */ React.createElement("div", { className: cx(defaultClasses.iconContainer, selected && defaultClasses.selected) }, icon) : null,
      /* @__PURE__ */ React.createElement("div", { className: cx(defaultClasses.label) }, label),
      hasChildren ? /* @__PURE__ */ React.createElement("span", { className: cx(defaultClasses.expander, expanded ? CustomIcon.ArrowUp : CustomIcon.ArrowDown) }) : null
    ), /* @__PURE__ */ React.createElement(TreeItemGroupTransition, { ...getGroupTransitionProps() })));
  }
);
function MenuTreeItem({
  children,
  menuIcon = "Profile",
  hideMenuIcon,
  title,
  id
}) {
  const { formatMessage } = useIntl();
  return /* @__PURE__ */ React.createElement(
    MenuTreeItemInner,
    {
      itemId: id,
      icon: !hideMenuIcon ? /* @__PURE__ */ React.createElement("span", { className: CustomIcon[menuIcon] }) : null,
      label: formatMessage(title),
      children,
      hasChildren: !!children
    }
  );
}
export {
  MenuTreeItem,
  MenuTreeItemInner,
  useStyles
};
//# sourceMappingURL=MenuTreeItem.js.map
